import { AssertionDescriptorUsageTypesEnum } from '../../utilities/Constants';
import { DocumentTitle } from '../../components/shared/DocumentTitle';
import { ExecutionPlan } from '../strategy/ExecutionPlan';
import { Loader } from '../../components/shared/Loader';
import { useAuthContext } from '../../contexts/AuthContext';
import { useLocation } from 'react-router-dom';
import { useZoneContext } from '../../contexts/useZoneContext';
import { useZoneGetAssertionDescriptors } from '../../shared/react-query-hooks/useZoneGetAssertionDescriptors';

function ExecutionPlanWrapper() {
    const { key } = useLocation();
    const { user } = useAuthContext();
    const zoneContext = useZoneContext();

    const assertionDescriptorStrategyLookup = useZoneGetAssertionDescriptors(
        AssertionDescriptorUsageTypesEnum.Strategy
    );

        const assertionDescriptorSignificantChangesLookup = useZoneGetAssertionDescriptors(
        AssertionDescriptorUsageTypesEnum.Note
    );

    if (assertionDescriptorStrategyLookup.isFetching || assertionDescriptorSignificantChangesLookup.isFetching) {
        return <Loader />;
    }

    return (
        <>
            <DocumentTitle title="Execution Plan" />
            <ExecutionPlan
                assertionDescriptorsStrategy={assertionDescriptorStrategyLookup.data ?? []}
                assertionDescriptorsSignificantChanges={assertionDescriptorSignificantChangesLookup.data ?? []}
                user={user}
                refreshIdentifier={key}
                zoneContext={zoneContext}
            />
        </>
    );
}

export default ExecutionPlanWrapper;
